<template>
  <div id="dcim-login">
    <div class="left">
      <transition name="slide-fade">
        <div v-show="show">
          <!-- <h1>DCIM</h1> -->
          <!-- <img src="@/assets/styles/images/efg1.png" height="100" alt="" /> -->
          <!-- <h3>高性能 / 精致 / 优雅</h3> -->
          <p class="desc">{{ desc }}</p>
        </div>
      </transition>
    </div>
    <div class="right">
      <transition name="login-body">
        <div class="login-body" v-show="show">
          <div class="header">
            <!-- <img src="@/assets/styles/images/efg5.png" alt="" /> -->
            <span >济南华东数字化产业园</span>
          </div>
          <el-tabs v-model="activeName" style="margin-left: 6px">
            <el-tab-pane label="账号登录" name="first">
              <el-form
                :model="formInline"
                :rules="rules"
                ref="ruleForm"
                class="login-form"
              >
                <el-row>
                  <el-form-item prop="username">
                    <el-input
                      prefix-icon="el-icon-user-solid"
                      v-model="formInline.username"
                      placeholder="用户名"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item prop="password">
                    <el-input
                      show-password
                      v-model="formInline.password"
                      placeholder="密码"
                      class="inputStyle"
                    >
                    </el-input>
                  </el-form-item>
                </el-row>
                <el-form-item>
                  <el-row type="flex">
                    <el-input
                      v-model="formInline.verifyCode"
                      placeholder="验证码"
                      style="margin-right: 20px"
                    ></el-input>
                    <div class="verify-img">
                      <img
                        @click="handleVerifyCode"
                        :src="verifyCodeUrl"
                        alt="验证码"
                        title="点击更换"
                        style="height: 100%"
                      />
                    </div>
                  </el-row>
                </el-form-item>
                <el-row>
                  <el-button
                    style="width: 100%; height: 45px"
                    type="primary"
                    round
                    @click="submitForm('ruleForm')"
                    >登录</el-button
                  >
                </el-row>
              </el-form>
              <!-- <el-divider class="other-text">其他方式登录</el-divider>
              <el-row class="other-box">
                <span class="other-icon">
                  <img :src="wachatUrl" alt="" />
                </span>
              </el-row> -->
            </el-tab-pane>
          </el-tabs>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { Tabs, TabPane, Divider, Image } from "element-ui";
import encryptor from "@/utils/rsa.js";
import commonUtil from "@/utils/common.js";
import { loginApi } from "@/apis";
export default {
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Divider.name]: Divider,
    [Image.name]: Image,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      activeName: "first",
      formInline: {
        username: "",
        password: "",
        clientId: "",
        grantType: "",
        responseType: "",
        verifyCode: "",
      },
      verifyCodeUrl: `${process.env.VUE_APP_VERIFYCODE}/verifyCode`,
      show: false,
      wachatUrl: require("@/assets/styles/images/wechat.png"),
      title: process.env.VUE_APP_TITLE,
      checked: "",
      code: "",
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        username: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
      },
      keepPassword: "",
      desc: "\u2003\u2003济南华东数字化产业园位于山东省济南市商河县，于2023年10月启动开工建设，计划2024年10月投产试运营，占地面积约20.6万平方米（310亩）。本数据来自前瞻产业研究院产业园区数据库，前瞻产业研究院20年持续聚焦全国细分产业研究、产业规划、产业园区规划、产业地产规划、特色小镇规划、产业新城规划及产业园区招商引资等，助力地方产业发展，促进产城融合。",
    };
  },
  beforeRouteEnter(to, from, next) {
    //登出清除token
    let { logout } = to.query;
    const token = localStorage.getItem("accessToken");
    if (logout && token) {
      localStorage.removeItem("accessToken");
    }
    next();
  },
  created() {
    this.setFormParams();
    this.show = false;
  },
  mounted() {
    this.enterKeyup();
    this.getCookie();
    this.show = true;
  },
  destroyed() {
    window.removeEventListener("keydown", this.enterKey());
  },
  methods: {
    setCookie(username, password, days) {
      let exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * days); //保存的天数
      window.document.cookie = `username=${username};path=/;expires=${exdate.toUTCString()}`;
      window.document.cookie = `password=${password};path=/;expires=${exdate.toUTCString()}`;
    },
    getCookie() {
      // console.log(document.cookie)
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "username") {
            this.formInline.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "password") {
            this.formInline.password = arr2[1];
          }
        }
        this.checked = true;
      }
    },
    clearCookie() {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    handleVerifyCode() {
      if (this.verifyCodeUrl) {
        this.verifyCodeUrl = `${
          process.env.VUE_APP_VERIFYCODE
        }/verifyCode?${Math.random()}`;
      }
    },
    //获取url参数传入formInline
    setFormParams() {
      const clientId = commonUtil.getUrlParam("clientId");
      const grantType = commonUtil.getUrlParam("grantType");
      const responseType = commonUtil.getUrlParam("responseType");
      if (clientId) this.formInline.clientId = clientId;
      if (grantType) this.formInline.grantType = grantType;
      if (responseType) this.formInline.responseType = responseType;
    },
    submitForm(formName) {
      let {
        username,
        password,
        verifyCode,
        clientId,
        responseType,
        grantType,
      } = this.formInline;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //加密密码
          let rsaPassWord = encryptor.encrypt(password);
          const req = {
            clientId,
            grantType,
            password: rsaPassWord,
            responseType,
            username,
            verifyCode,
          };
          if (!clientId) delete req.clientId;
          if (!grantType) delete req.grantType;
          if (!responseType) delete req.responseType;
          loginApi.login(req).then((res) => {
            if (res.resultCode === "0000") {
              //保存账号密码到cookie
              if (this.checked) {
                this.setCookie(username, password, 3);
              } else {
                this.clearCookie();
              }
              let { redirectUri, accessToken } = res.data;
              // 在localStoage存储token
              let storage = window.localStorage;
              storage.setItem("accessToken", accessToken);
              // redirectUri = 'http://localhost:8082'
              this.$message.success({
                message: "登录成功",
                duration: "1000",
                onClose: () => {
                  window.location.href = `${redirectUri}?accessToken=${accessToken}`;
                },
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    enterKey(e) {
      if (e.keyCode === 13) {
        this.submitForm("ruleForm");
      }
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },
    dleClick() {},
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  height: 45px;
}
#dcim-login {
  display: flex;
  height: 100%;
  .left {
    flex: 1;
    background-image: url("~@/assets/styles/images/login-bg.jpg");
    color: #fff;
    background-repeat: no-repeat;
    padding: 40px 0 0 30px;
    background-size: cover;
    background-position: 50%;
    .desc {
      color: #c0c4cc;
      width: 450px;
      line-height: 40px;
    }
  }
  .right {
    flex: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    bottom: 5%;
    .login-body {
      width: 450px;
      .login-form {
        padding: 10px 0;
        .verifyCode {
          display: flex;
        }
      }
      .header {
        display: flex;
        align-items: center;
        margin-bottom: 28px;
        img {
          width: 104px;
          height: 70px;
        }
        span {
          color: #e40001;
          font-weight: bold;
          font-size: 30px;
          // margin: 0 20px;
        }
      }
      .verify-img {
        height: 45px;
      }
    }
  }
}

.other-box {
  display: flex;
  justify-content: center;
  .other-icon {
    display: inline-block;
  }
}
::v-deep .el-divider__text {
  color: #909399;
}
/* 动画 */
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-enter {
  transform: translateX(-40px);
  opacity: 0;
}

.login-body-enter-active {
  transition: all 1s ease;
}

.login-body-enter {
  transform: translateY(-100%);
  opacity: 0;
}
</style>